window.canUpdate = true;
window.setUpdatingFlag = (n, timeout = 150) => {
  window.canUpdate = false;
  // console.log("Updates disabled", n);
  let timer;
  clearTimeout(timer);
  timer = setTimeout(() => {
    window.canUpdate = true;
    // console.log("Updates enabled", n);
  }, timeout);
};

window.observer_mutation = (target, cb, config, disconnect = false) => {
  // console.log("in observer_mutation", target);
  // Options for the observer (which mutations to observe)
  var config = config || {
    attributes: true,
    childList: true,
    subtree: true,
  };
  // Callback function to execute when mutations are observed
  const callback = (mutationList, observer) => {
    // Use traditional 'for loops' for IE 11
    for (const mutation of mutationList) {
      typeof cb === "function" && cb(mutation);
    }
  };
  const mo = new MutationObserver(callback);
  mo.observe(target, config);

  // Later, you can stop observing
  console.log(target, disconnect);
  if (disconnect) {
    mo.disconnect();
  }
};

window.pdp_sliders = () => {
  const { pt_main_slider, pt_thumb_slider, pt_sticky_slider } = window.theme;

  let mainSliderConfig = {
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    prevArrow:
      '<button class="slick-arrow slick-prev" aria-label="Previous"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M15 3l-9 9 9 9"></path></svg></button>',
    nextArrow:
      '<button class="slick-arrow slick-next" aria-label="Next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M9 3l9 9-9 9"></path></svg></button>',
  };

  let thumbSliderConfig = {
    asNavFor: $(pt_main_slider),
    arrows: false,
    dots: false,
    slidesToScroll: 1,
    slidesToShow: 6,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 481,
        settings: "unslick",
      },
    ],
  };

  if ($(pt_thumb_slider)) {
    mainSliderConfig.asNavFor = $(pt_thumb_slider);
    $(pt_thumb_slider).not(".slick-initialized").slick(thumbSliderConfig);
  }
  if ($(pt_main_slider)) {
    $(pt_main_slider).not(".slick-initialized").slick(mainSliderConfig);
  }

  if ($(pt_sticky_slider)) {
    $(pt_sticky_slider).not(".slick-initialized").slick({
      dots: false,
      slidesToScroll: 1,
      slidesToShow: 1,
      centerMode: true,
      infinite: false,
      prevArrow:
        '<button class="slick-arrow slick-prev" aria-label="Previous"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M15 3l-9 9 9 9"></path></svg></button>',
      nextArrow:
        '<button class="slick-arrow slick-next" aria-label="Next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M9 3l9 9-9 9"></path></svg></button>',
    });
  }
};

window.updateSlider = (slider, variant) => {
  let slide = slider.find(
    `.product-image-slide:not(.slick-cloned)[data-media="${variant.featured_media.id}"]`
  );
  let slideno = $(slide).data("slick-index");
  slider.slick("slickGoTo", slideno);
};

$(function () {
  const {
    pt_main_slider,
    pt_thumb_slider,
    pt_sticky_slider,
    pt_variants,
    pt_product_form,
    pt_options,
  } = window.theme;

  // runs directly
  window.pdp_sliders();

  // runs on variant change
  document.addEventListener("product:variant-change", function (e) {
    if (window.innerWidth < 481) {
      $(
        `.product-image-slide[data-media="${e.detail.variant.featured_media.id}"] img`,
        $(pt_thumb_slider)
      ).click();
    } else {
      window.updateSlider($(pt_thumb_slider), e.detail.variant);
    }
    window.updateSlider($(pt_sticky_slider), e.detail.variant);
  });

  $(pt_sticky_slider).on("afterChange", function (event, slick, currentSlide) {
    let CurrentSlideDom = $(slick.$slides.get(currentSlide));
    let CurrentSlideDomVariantId = CurrentSlideDom.data("variant");
    let CurrentSlideDomVariant = pt_variants.find(
      (variant) => variant.id === CurrentSlideDomVariantId
    );
    if (window.canUpdate) {
      window.setUpdatingFlag(00);

      // select updated variant options
      CurrentSlideDomVariant.options.map((option, i) => {
        console.log("Selecting::", pt_options[i].name, option);
        $(`[name="${pt_options[i].name}"][value="${option}"]`).prop(
          "checked",
          true
        );
      });

      // update variant id in main form
      $('[name="id"]', $(pt_product_form)).val(CurrentSlideDomVariantId);
      $(".sticky-variant").text(CurrentSlideDomVariant.title);

      // announce variant change
      // dispatchCustomEvent("product:variant-change", {
      //   variant: CurrentSlideDomVariant,
      // });

      // trigger change event for options
      document
        .querySelector("variant-selects")
        .dispatchEvent(new Event("change"));
    }
  });

  if (window.innerWidth < 481) {
    $(pt_main_slider).on("afterChange", function (event, slick, currentSlide) {
      // window.setUpdatingFlag(22);
      let currentSlideDom = $(slick.$slides.get(currentSlide));
      let mediaId = currentSlideDom.data("media");
      let scroller = $(pt_thumb_slider);
      let scrollTo = $(`[data-media="${mediaId}"]`, scroller);
      $(`.product-image-slide`, scroller).removeClass("active-slide");
      scroller.scrollLeft(scrollTo.index() * (110 + 15));
      scrollTo.addClass("active-slide");
    });

    $(`.product-image-slide img`, $(pt_thumb_slider)).on("click", function (e) {
      if (e.originalEvent === undefined) {
        // window.setUpdatingFlag(11, 750);
      }
      let thumbSlide = $(this).closest(".product-image-slide");
      let mediaId = thumbSlide.data("media");
      $(`.product-image-slide`, $(pt_thumb_slider)).removeClass("active-slide");
      let mainSlide = $(pt_main_slider).find(
        `.product-image-slide:not(.slick-cloned)[data-media="${mediaId}"]`
      );
      let slideno = $(mainSlide).data("slick-index");
      $(pt_main_slider).slick("slickGoTo", slideno);
      thumbSlide.addClass("active-slide");
    });
  }
});
